import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgbModule, NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { AngularEditorModule } from "@kolkov/angular-editor";
import { NgxMaterialToolsModule } from 'ngx-material-tools';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule} from '@angular/material/button';
import { MatInputModule} from '@angular/material/input';
import { MatFormFieldModule} from '@angular/material/form-field';
import { MatMenuModule } from '@angular/material/menu';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { NgxMatDatetimePickerModule, NgxMatTimepickerModule, NgxMatNativeDateModule } from '@angular-material-components/datetime-picker';

//import { MatNativeDateModule,MatDialogModule } from '@angular/material';

import { MatNativeDateModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';

import { MatTableModule } from '@angular/material/table';
import { MatListModule } from '@angular/material/list';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MaterialFileInputModule } from 'ngx-material-file-input';
import { NgxCopyToClipboardModule } from 'ngx-copy-to-clipboard';
import { NgxSpinnerModule } from 'ngx-spinner';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { AppLayoutComponent } from './layout/app-layout/app-layout.component';
import { TopBarComponent } from './menu/top-bar/top-bar.component';
import { SideBarComponent } from './menu/side-bar/side-bar.component';
import { EscapeHtmlPipe } from './directives/keep-html.pipe';
import { SideBarParametrageComponent } from './menu/side-bar-parametrage/side-bar-parametrage.component';
import { ParametrageLayoutComponent } from './layout/parametrage-layout/parametrage-layout.component';
import { SideBarRightComponent } from './menu/side-bar-right/side-bar-right.component';
import { TopBarParametrageComponent } from './menu/top-bar-parametrage/top-bar-parametrage.component';
import { SideBarAccountComponent } from './menu/side-bar-account/side-bar-account.component';
import { AccountLayoutComponent } from './layout/account-layout/account-layout.component';
import { NavBarHorizontalComponent } from './menu/nav-bar-horizontal/nav-bar-horizontal.component';
import { DateFormatPipe } from './directives/date-format.pipe';
import { HasPermissionDirective } from './directives/hasPermission.directive';
import { UserService } from './directives/user.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { UiSwitchModule } from 'ngx-ui-switch';
import { PdfJsViewerModule } from "ng2-pdfjs-viewer";
import { ImageViewerModule } from "ng2-image-viewer";
import { NgxDocViewerModule } from "ngx-doc-viewer";
import { HighchartsChartModule } from 'highcharts-angular';
import { NgbdSortableHeader } from './directives/sortable.directive';
import { PushNotificationsService } from '../core/services/WebSocket/push.notification.service';

@NgModule({
  imports: [
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    NgbModalModule,
    NgbModule,
    AngularEditorModule,

    //
    NgxMaterialToolsModule,
    MatCardModule,
    MatInputModule,
    MatFormFieldModule,
    MatButtonModule,
    MatMenuModule,
    MatDatepickerModule,
    NgxMatTimepickerModule,
    NgxMatDatetimePickerModule,
    MatCheckboxModule,
    MatRadioModule,
    MatSelectModule,
    NgxMatNativeDateModule,
    MatNativeDateModule,
    MatDialogModule,
    MatTableModule,
    MatListModule,
    MatPaginatorModule,
    MatSortModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MaterialFileInputModule,
    //

    NgxCopyToClipboardModule,
    NgSelectModule,
    UiSwitchModule,
    NgxSpinnerModule,

    PdfJsViewerModule,
    ImageViewerModule,
    NgxDocViewerModule,
    HighchartsChartModule
  ],
  declarations: [
    BreadcrumbComponent,
    EscapeHtmlPipe,
    DateFormatPipe,
    HasPermissionDirective,
    NgbdSortableHeader,
    
    AppLayoutComponent,
    TopBarComponent,
    SideBarComponent,
    SideBarParametrageComponent,
    ParametrageLayoutComponent,
    SideBarRightComponent,
    TopBarParametrageComponent,
    SideBarAccountComponent,
    AccountLayoutComponent,
    NavBarHorizontalComponent
  ],
  providers: [
    UserService,
    PushNotificationsService
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    EscapeHtmlPipe,
    NgbModalModule,
    NgbModule,
    DateFormatPipe,
    HasPermissionDirective,
    AngularEditorModule,
    
    //
    NgxMaterialToolsModule,
    MatCardModule,
    MatInputModule,
    MatFormFieldModule,
    MatButtonModule,
    MatMenuModule,
    MatDatepickerModule,
    NgxMatTimepickerModule,
    NgxMatDatetimePickerModule,
    MatCheckboxModule,
    MatRadioModule,
    MatSelectModule,
    NgxMatNativeDateModule,
    MatNativeDateModule,
    MatDialogModule,
    MatTableModule,
    MatListModule,
    MatPaginatorModule,
    MatSortModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MaterialFileInputModule,
    //

    NgxCopyToClipboardModule,
    NgSelectModule,
    UiSwitchModule,
    NgxSpinnerModule,
      
    PdfJsViewerModule,
    ImageViewerModule,
    NgxDocViewerModule,
    HighchartsChartModule,

    NgbdSortableHeader
  ],
  entryComponents: [ ]
})
export class SharedModule { }